export enum BuiltFilePaths {
  Taskpane = '/taskpane.html',
  Auth = '/Index.html',
  SignInRedirect = '/RedirectTest.html',
  SilentRenew = '/SilentRenew.html',
}

export enum QueryParamKeys {
  Signout = 'signout',
  /** Set on `post_logout_redirect_uri` so the redirect page can notify the parent task pane. */
  SignoutCallback = 'signout_callback',
  Window = 'window',
  Formula = 'formula',
  Value = 'value',
  /** Passed to the auth dialog so the IdP can pre-fill the account (OIDC `login_hint`). */
  LoginHint = 'login_hint',
}

export enum QueryParamWindowValues {
  CustomModel = 'customModel',
  TBBreakdownModal = 'TBBreakdownModal',
  InsertTemplate = 'InsertTemplate',
  InsertMFD = 'InsertMFD',
  EngagementSummaryModal = 'EngagementSummaryModal',
  InsertEngagementDetails = 'InsertEngagementDetails',
  InsertEditProcedureOrResponseModal = 'InsertEditProcedureOrResponseModal',
}

export enum LinkedEntityCellTypes {
  SingleEngagementDetails = 'singleEngagementDetails',
  Procedures = 'procedures',
  Responses = 'responses',
}

export enum DialogState {
  DialogReady = 'DIALOG_READY',
}

/** Payloads sent from auth Office dialogs to the parent task pane via `messageParent`. */
export enum AuthDialogMessage {
  SignInSuccess = 'AUTH_SUCCESS',
  SignOutComplete = 'AUTH_SIGNED_OUT',
}
